export default "__VITE_ASSET__8fee5d7c__"